// D-363: CSS-variable-driven palette. One root change switches theme.
export const B = {
  bg: "var(--color-bg)", surface: "var(--color-surface-raised)",
  accent: "var(--color-accent)", accentLight: "var(--color-accent-light)", accentDark: "var(--color-accent-dark)",
  green: "var(--color-success)", amber: "var(--color-warning)", red: "var(--color-critical)", cyan: "#06b6d4", indigo: "#6366f1",
  purple: "#a855f7", threshold: "var(--color-threshold)",
  text: "var(--color-text-primary)", textSec: "var(--color-text-secondary)", muted: "var(--color-text-muted)", subtle: "var(--color-text-muted)",
  border: "var(--color-border)", borderMed: "var(--color-border-med)",
  fridge: "var(--color-fridge)",
};

// D-363: Intelligence feed always-dark palette (InsightFeed, ActionPreview)
export const INTEL = {
  bg: "var(--color-intel-bg)",
  surface: "var(--color-intel-surface)",
  text: "var(--color-intel-text)",
  textSec: "var(--color-intel-text-sec)",
  muted: "var(--color-intel-muted)",
  border: "var(--color-intel-border)",
  accent: "var(--color-intel-accent)",
};

// D-275: Typography system -- warm dark editorial
export const T = {
  display: "'IBM Plex Serif', Georgia, serif",
  body: "'IBM Plex Sans', -apple-system, sans-serif",
  mono: "'IBM Plex Mono', 'SF Mono', monospace",
  // Scale: major third (1.25)
  displayXL: { fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 28, fontWeight: 400, lineHeight: 1.2, letterSpacing: "-0.01em" },
  displayLG: { fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 22, fontWeight: 400, lineHeight: 1.25, letterSpacing: "-0.005em" },
  displayMD: { fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 18, fontWeight: 400, lineHeight: 1.3 },
  displaySM: { fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 15, fontWeight: 500, lineHeight: 1.35 },
  bodyLG:    { fontFamily: "'IBM Plex Sans', sans-serif", fontSize: 14, fontWeight: 400, lineHeight: 1.6 },
  bodyMD:    { fontFamily: "'IBM Plex Sans', sans-serif", fontSize: 13, fontWeight: 400, lineHeight: 1.55 },
  bodySM:    { fontFamily: "'IBM Plex Sans', sans-serif", fontSize: 11, fontWeight: 400, lineHeight: 1.5 },
  label:     { fontFamily: "'IBM Plex Sans', sans-serif", fontSize: 10, fontWeight: 600, lineHeight: 1.4, letterSpacing: "0.06em", textTransform: "uppercase" },
  data:      { fontFamily: "'IBM Plex Mono', monospace", fontSize: 13, fontWeight: 500, lineHeight: 1.3 },
  // D-540: Dollar amounts — Noto Serif Black, gold
  dollar:    { fontFamily: "'Noto Serif', Georgia, serif", fontWeight: 900, color: "#C9A84C" },
};

export const PROFILES = {
  dipak: { id: "dipak", name: "Dipak Kamdar", role: "Partner & CRO, SAVD BY AI", avatar: "D", color: B.accent, llc: "SAVD BY AI LLC" },
  purvi: { id: "purvi", name: "Purvi Modi", role: "Household Finance", avatar: "P", color: B.purple, llc: null },
};
export const LLC_KEYWORDS = ["aws","anthropic","notion","zoom","google workspace","adobe","figma","vercel","openai","linkedin","stripe","twilio","dropbox","slack","hubspot","salesforce","canva","loom","calendly","docusign"];
export const CATEGORIES = ["Software/SaaS","Travel & Transport","Meals & Entertainment","Office Supplies","Marketing","Professional Services","Utilities","Personal","Groceries","Healthcare","Subscriptions","Other"];

export function fmt(n) { return new Intl.NumberFormat("en-US",{style:"currency",currency:"USD",maximumFractionDigits:0}).format(Math.abs(n)); }
export function fmtFull(n) { return new Intl.NumberFormat("en-US",{style:"currency",currency:"USD",minimumFractionDigits:2,maximumFractionDigits:2}).format(Math.abs(n)); }
